import {Circle1} from "../../Shapes/Section2/Circle1";
import {Circle2} from "../../Shapes/Section2/Circle2";
import {Dots} from "../../Shapes/Dots/Dots";
import sampleImage2 from "../../../../public/static/photojoiner.com-photo-stitch-sample-2.webp";
import Image from "next/image";
import {isMobile} from "react-device-detect";

export interface IStitchFeatureSection2Props {
  backgroundColor: string;
  imageSrc: string;
  circle1Color: string;
  circle2Color: string;
  dots1Color?: string;
  dots2Color?: string;
}

export const StitchFeatureSection2 = ({
  backgroundColor,
  circle1Color: circle1Color,
  circle2Color: circle2Color,
  imageSrc,
  dots1Color = "transparent",
  dots2Color = "transparent",
}: IStitchFeatureSection2Props) => {
  return (
    <div
      className="py-24 px-4 lg:px-0 xl:px-52 2xl:px-104"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col-reverse lg:flex-row">
        <div className="w-full flex justify-center lg:justify-end ">
          <div className="relative bg-red-500 w-full aspect-[1.18]">
            {/* <img src={imageSrc} className="opacity-0"  alt="Collage Maker by PhotoJoiner"/> */}
            <div className="absolute inset-0 z-10 flex ">
              <Image
                src={sampleImage2}
                className="shadow-lg"
                alt="Collage Maker by PhotoJoiner"
                width={isMobile ? 500 : 1000}
                sizes={`max-width: ${isMobile?500:1000}px`}
              />
            </div>

            <div className="hidden lg:block absolute top-0 left-0 -translate-x-1/4 -translate-y-16">
              <Circle1 fill={circle1Color} />
            </div>

            <div
              className={`hidden lg:block absolute bottom-0 left-1/2 translate-y-1/3 ${
                dots2Color === "transparent"
                  ? "translate-x-1/2"
                  : "-translate-x-1/3"
              }`}
            >
              <Circle2 fill={circle2Color} />
            </div>

            <div className="hidden lg:block absolute right-0 top-0 -translate-x-1/3 -translate-y-1/4">
              <Dots fill={dots1Color} />
            </div>

            <div className="hidden lg:block absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4">
              <Dots fill={dots2Color} />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center gap-4 lg:pl-24">
          <div className="text-5xl lg:text-6xl" style={{ maxWidth: "16ch" }}>
            <h2>Merge Photos Horizontally or Vertically</h2>
          </div>
          <div className="leading-relaxed " style={{ maxWidth: "45ch" }}>
            Whether you want to merge your photos vertically or horizontally,
            this tool makes it super easy. Simply upload your images and then
            select either a horizontal or vertical layout. Plus you can easily
            adjust the order by simply dragging images around.
          </div>
        </div>
      </div>
    </div>
  );
};
